import { connect } from "react-redux";
import { List } from "./list.component";

export const ListContainer = connect(
  (state) => ({ cards: state.card.list }),
  null
)(List);
